import { render, staticRenderFns } from "./SpecificationTable.vue?vue&type=template&id=c73970d0&scoped=true&"
import script from "./SpecificationTable.vue?vue&type=script&lang=js&"
export * from "./SpecificationTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecificationTable.vue?vue&type=style&index=0&id=c73970d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73970d0",
  null
  
)

export default component.exports